import { render, staticRenderFns } from "./Item.audioButton.vue?vue&type=template&id=f2f8d1d0&"
import script from "./Item.audioButton.vue?vue&type=script&lang=js&"
export * from "./Item.audioButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports